import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2, OnDestroy, TemplateRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PlaybookCommunicationService } from '../../shared/services/playbook-communication.service';
import { serverUrl, devicePixelRatio, Modalconfig, imageAllowedExtension, DefaultLanguageId } from 'src/app/shared/constants';
import { ContentBlock, VideoBlock, Asset } from 'src/app/shared/model/container.models';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { clone, includes } from 'lodash';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { ConfirmationModelComponent } from 'src/app/shared/components/confirmation-model/confirmation-model.component';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
    selector: 'app-video',
    templateUrl: './video.component.html',
    styleUrls: ['./video.component.scss'],
    standalone: false
})
export class VideoComponent implements OnInit, OnDestroy {

  @Input('contentBlock') contentBlock: ContentBlock;
  @ViewChild('videoCont') videocont: ElementRef<any>;
  @ViewChild('AddEditVideo') AddEditVideo: TemplateRef<any>;
  @Input() sectionId: number;
  @Input() containerId: number;
  @Input() isdraftmode: boolean;
  @Input() pageTemplateId: number;
  videoListPerSection = [];
  isPlaying = false;
  primaryUrl: string = null;
  selectedFile: any;
  thumbNailStyle;
  subscription;
  secondaryUrl: string = null;
  serverUrl = serverUrl;
  updateSubsciption: Subscription;
  modalRef: BsModalRef;
  vidBlock: VideoBlock;
  showProgress = {
    mp4: null,
    image: null
  };
  confModalRef: BsModalRef;
  confModalSubsciber: Subscription;
  videoContentSubscription: Subscription;
  uploadedResource = {
    mp4: null,
    webm: null,
    image: null
  };
  progressPercent = {
    mp4: 0,
    image: 0
  };
  isProgressing = {
    mp4: 0,
    image: 0
  };
  videoProcessing: string;
  devicePixelRatio = devicePixelRatio;
  defaultLanguageId = DefaultLanguageId;
  languageId: number;
  apiUrl = '/api/Assets/UploadVideoFileAsChunk';
  isEmbedThirdPartyUrl = false;
  constructor(
    public san: DomSanitizer,
    private commService: PlaybookCommunicationService,
    private renderer: Renderer2,
    private commonHttpService: CommonHttpService,
    private modalService: BsModalService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private storage: LocalStorageService
  ) {
    /**
     * To pause played video if another video will be played in playbook
     */
    this.subscription = this.commService.getCurrentVideoId()
      .subscribe(videoBlockId => {
        if (this.isPlaying && this.contentBlock.videoBlock && videoBlockId !== this.contentBlock.videoBlock.id) {
          this.isPlaying = !this.isPlaying;
          setTimeout(() => {
            this.renderer.setStyle(this.videocont.nativeElement.children[0], 'background-image', `url("/assets/img/pause.png")`);
          }, 10);
        }
      });

    // To handle Add/Edit modal opening when clicked from settings wrapper
    this.updateSubsciption = this.commService.getAddEditContentBlock().subscribe((contentBlockId) => {
      if (this.contentBlock.id === contentBlockId) {
        if (!this.contentBlock.videoBlock) {
          this.contentBlock.videoBlock = new VideoBlock();
          this.contentBlock.videoBlock.external = false;
        }
        this.vidBlock = clone(this.contentBlock.videoBlock);
        if (this.vidBlock.url && this.vidBlock.url.includes('assets')) {
          this.vidBlock.url = null;
        }
        
        if((window === window.parent || ( (window != window.parent) && window.location != window.parent.location ))) {
          this.modalRef = this.modalService.show(this.AddEditVideo,
            Object.assign({ class: 'custom-modal' }, Modalconfig));
        } else {
          this.videoContentSubscription = this.storage.observe('uploadVideoContent').subscribe((uploadContentBlock) => {
            if ((window !== window.parent && window.location == window.parent.location) && uploadContentBlock) {
              this.vidBlock.url = uploadContentBlock.videoObj.url;
              this.vidBlock.assetId = uploadContentBlock.videoObj.assetId;
              this.vidBlock.caption = uploadContentBlock.videoObj.caption;
              this.vidBlock.external = uploadContentBlock.videoObj.external;
              this.vidBlock.placeHolderImageId = uploadContentBlock.videoObj.placeHolderImageId;
              this.vidBlock.videoTitle = uploadContentBlock.videoObj.videoTitle;
              this.vidBlock.talentName = uploadContentBlock.videoObj.talentName;
              this.vidBlock.description = uploadContentBlock.videoObj.description;
              this.videoListPerSection = uploadContentBlock.videoListPerSection;
              this.updateVideoBlock(false);
            }
          });
          this.storage.store("videoContentBlock", this.contentBlock);
        }
      }
    });
  }

  ngOnInit() {
    this.setVideoUrls();
    this.languageId = +this.activatedRoute.snapshot.queryParams.languageId || this.defaultLanguageId;
  }

  /**
   * To set url for video component based on type of video
   */
  setVideoUrls() {
    if (this.contentBlock.videoBlock != null) {
      switch (this.contentBlock.videoBlock.videoType) {
        case 1:
          this.primaryUrl = 'https://player.vimeo.com/video/' + this.contentBlock.videoBlock.url.match(/([0-9])/g).join('');
          break;
        case 2:
          this.getYouTubeUrl(this.contentBlock.videoBlock.url);
          break;
        default:
          const placeHolderImageId = this.contentBlock.videoBlock.placeHolderImageId;
          if(this.contentBlock.videoBlock.url) {
            this.primaryUrl = this.contentBlock.videoBlock.url;
          }
          if (placeHolderImageId) {
            const token = this.authService.token();
            this.thumbNailStyle = {
              'background-image': `url(${serverUrl}/api/Assets/GetPlaybookTilesImage/${placeHolderImageId}?width=1024&ratio=${this.devicePixelRatio}&access_token=${token})`,
              width: '100%',
            };
          } else {
            this.thumbNailStyle = {
              'background-image': 'none',
              width: '100%',
            };
          }
          break;
      }
    }
  }

  /**
   * To get youtube ember url based on url in menifest
   */
  getYouTubeUrl(url) {
    const vid = url.match(/((=|\/){1})(\w|\d|-)*$/g);
    this.primaryUrl = url;
    if (vid != null && vid.length > 0) {
      this.primaryUrl = 'https://youtube.com/embed/' + url.match(/((=|\/){1})(\w|\d|-)*$/g).join('').replace('=', '').replace('/', '') + '?rel=0';
    }
  }

  /**
   * True when the block carries its own placeholder image. Without one the
   * placeholder div renders as a blank white box, so we let the video element
   * show its own first frame instead.
   */
  get hasPlaceholderImage(): boolean {
    return !!(this.contentBlock?.videoBlock?.placeHolderImageId);
  }

  /**
   * The video element stays visible when it is the thing providing the preview
   * frame, so playback started from its native controls still registers.
   */
  onViewerPlaybackStarted() {
    if (!this.isPlaying) {
      this.isPlaying = true;
      this.commService.sendCurrentVideoId(this.contentBlock.videoBlock.id);
    }
  }

  /**
   * To play clicked video and pause other video which is being played
   */
  playVideo() {
  
    this.isPlaying = !this.isPlaying;
    this.commService.sendCurrentVideoId(this.contentBlock.videoBlock.id);
  }

  /**
   * Method to handle validation of file format before uploading
   * @param event FileUploader event containing Content to be uploaded
   * @param fileType FileType to handle content accordingly
   */
  fileSelected(event, fileType) {
    this.selectedFile = event.target.files[0] as File;
    switch (fileType) {
      case 1:
        if (this.selectedFile.type.match('video/mp4')) {
          this.uploadResource(this.selectedFile, 1);
        } else {
          const initialState = {
            msg: 'This is not a valid extension. Supported extensions is : mp4',
            showCancelBtn: false
          };
          this.confModalRef = this.modalService.show(ConfirmationModelComponent,
            Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
          this.confModalSubsciber = this.confModalRef.content.onclose.subscribe((res) => {
            this.confModalRef.hide();
            this.confModalSubsciber.unsubscribe();
          });
        }
        break;
      case 3:
        const isValidExtension = this.validateExtension();
        if (isValidExtension) {
          this.uploadResource(this.selectedFile, 3);
        } else {
          const initialState = {
            msg: 'This is not a valid extension. Supported extensions are : ' + imageAllowedExtension.join(',') + '.',
            showCancelBtn: false
          };
          this.confModalRef = this.modalService.show(ConfirmationModelComponent,
            Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
          this.confModalSubsciber = this.confModalRef.content.onclose.subscribe((res) => {
            this.confModalRef.hide();
            this.confModalSubsciber.unsubscribe();
          });
        }
        break;
      default:
        break;
    }
  }

  validateExtension() {
    const extensionArray = this.selectedFile.name.split('.');
    const extension = extensionArray[extensionArray.length - 1].toLowerCase();
    const isValidExtension = includes(imageAllowedExtension, extension);
    return isValidExtension;
  }

  /**
   * Method to upload resource to server
   * @param selectedFile File data for uploading
   * @param fileType Filetype for setting response accordingly after uploading
   */
  uploadResource(selectedFile, fileType) {
    this.isProgressing.image = 1;
    const formData = new FormData() as any;
    formData.append('file', selectedFile);
    this.showProgress.image = true;
    this.commonHttpService.postWithProgress(
      {
        uri: fileType === 3 ? '/api/Assets/UploadImage' : '/api/Assets/UploadResource',
        object: formData
      }).subscribe((response: Asset | number) => {
        if (typeof response === 'number') {
          this.progressPercent.image = response;
        } else if (response) {
          this.showAsset(selectedFile, fileType, response);
        }
      }, (error) => {
        this.isProgressing.image = 0;
      });
  }

  showAsset(selectedFile, fileType, response, urlData?) {
    if (fileType === 1) {
      if (urlData) {
        this.uploadedResource.mp4 = urlData.saasUrl;
      }
      this.vidBlock.asset = response;
      this.vidBlock.assetId = response.id;
      this.showProgress.mp4 = false;
      this.progressPercent.mp4 = 0;
      this.isProgressing.mp4 = 0;
    } else {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(selectedFile);
      fileReader.onload = (e) => {
        this.uploadedResource.image = fileReader.result;
        this.vidBlock.placeHolderImageId = response.id;
        this.vidBlock.placeHolderImage = response;
        this.showProgress.image = false;
        this.progressPercent.image = 0;
        this.isProgressing.image = 0;
      }
    }
  }

  progressPercentage(progress) {
    this.showProgress.mp4 = true;
    this.isProgressing.mp4 = 1;
    if (typeof progress.percentage === 'number') {
      this.progressPercent.mp4 = progress.percentage;
      this.videoProcessing = progress.text;
    } else {
      this.progressPercent.mp4 = 100;
      this.videoProcessing = progress.percentage;
    }
  }

  fileStatusUpdate(fileStatus) {
    if (fileStatus.status) {
      this.showAsset(fileStatus.file, 1, fileStatus.assetData, fileStatus.url);
    }
  }

  /**
   * To set srcs for preview for different contents
   * @param fileType File type for uploading different content type
   */
  getAssetSrc(fileType) {
    if (fileType === 1) {
      if (this.uploadedResource.mp4 != null) {
        return this.uploadedResource.mp4;
      } else if (this.vidBlock.assetId) {
        return '/api/Assets/GetResourceById/' + this.vidBlock.assetId;
      }
    } else {
      if (this.uploadedResource.image != null) {
        return this.uploadedResource.image;
      } else if (this.vidBlock.placeHolderImageId) {
        return '/api/Assets/Image/' + this.vidBlock.placeHolderImageId;
      }
    }
    return '';
  }

  /**
   * To remove perticular file on click of remove button by user
   * @param fileType File type for uploading different content type
   */
  removeAsset(fileType) {
    switch (fileType) {
      case 1:
        this.vidBlock.asset = null;
        this.vidBlock.assetId = null;
        break;
      case 3:
        this.vidBlock.placeHolderImageId = null;
        this.vidBlock.placeHolderImage = null;
        break;
      default:
        break;
    }
  }

  /**
   * To add or update videoBlock
   */
  updateVideoBlock(isClose = true) {
    let reqObj = {
      id: null,
      playbookId: this.contentBlock.playbookId,
      contentBlockId: this.contentBlock.id,
      url: this.vidBlock.url,
      assetId: this.vidBlock.external ? null : this.vidBlock.assetId,
      caption: this.vidBlock.caption,
      external: this.vidBlock.external,
      placeHolderImageId: this.vidBlock.placeHolderImageId ? this.vidBlock.placeHolderImageId : null,
      pageTemplateId: this.pageTemplateId,
      videoTitle: this.vidBlock.videoTitle,
      talentName: this.vidBlock.talentName,
      description: this.vidBlock.description
    };
    if (this.vidBlock.id == null) {
      this.commonHttpService.postWithHeaders({
        uri: '/api/VideoBlocks',
        object: reqObj
      }, {
        pageId: this.containerId,
        sectionId: this.sectionId,
        playbookId: this.contentBlock.playbookId,
        languageId: this.languageId,
        isdraftmode: this.isdraftmode
      }).subscribe((response: VideoBlock) => {
        this.vidBlock = null;
        this.contentBlock.videoBlock = response;
        this.setVideoUrls();
        this.updateThumbNail();
        if(isClose) {
          this.modalRef.hide();
        } else {
          this.videoContentSubscription.unsubscribe();
          this.storage.store("uploadVideoContent", null);
        }
      });
    } else {
      reqObj.id = this.vidBlock.id;
      this.commonHttpService.putWithHeaders({
        uri: '/api/VideoBlocks',
        object: reqObj
      }, {
        pageId: this.containerId,
        sectionId: this.sectionId,
        playbookId: this.contentBlock.playbookId,
        languageId: this.languageId,
        isdraftmode: this.isdraftmode
      }).subscribe((response: VideoBlock) => {
        this.vidBlock = null;
        this.contentBlock.videoBlock = response;
        this.setVideoUrls();
        this.updateThumbNail();
        if(isClose) {
          this.modalRef.hide();
        } else {
          this.videoContentSubscription.unsubscribe();
          this.storage.store("uploadVideoContent", null);
        }
      });
    }
  }

  updateThumbNail() {
    if (this.videoListPerSection && this.videoListPerSection.length) {
      this.videoListPerSection.forEach((contSection) => {
        if (contSection.contentBlocsList.length) {
          contSection.contentBlocsList.forEach((contentBlock) => {
            if (contentBlock.videoBlock.id === this.contentBlock.videoBlock.id) {
              contentBlock.videoBlock = this.contentBlock.videoBlock;
              const placeHolderImageId = contentBlock.videoBlock.placeHolderImageId;
              if (placeHolderImageId) {
                const token = this.authService.token();
                contentBlock.videoBlock.thumbNailStyle = {
                  'background-image': `url(${serverUrl}/api/Assets/GetPlaybookTilesImage/${placeHolderImageId}?width=1024&ratio=${this.devicePixelRatio}&access_token=${token})`,
                  width: '100%',
                };
              } 
            }
          });
        }
      });
    }
  }

  /**
   * Method to open file dialog according to fileType
   * @param fileType File type for uploading different content type
   */
  openFileDialog(fileType) {
    if (fileType === 1) {
      $('#uploadMp4').trigger('click');
    } else {
      $('#uploadplaceholder').trigger('click');
    }
  }

  closeEditVideoModal() {
    this.modalRef.hide();
    setTimeout(() => {
      this.isProgressing.image = 0;
      this.isProgressing.mp4 = 0;
      this.progressPercent.mp4 = 0;
      this.progressPercent.image = 0;
      this.showProgress.image = false;
      this.showProgress.mp4 = false;
    },1000)
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.updateSubsciption) {
      this.updateSubsciption.unsubscribe();
    }
  }

  checkVideoUrl(videoUrl: string) {
    return !!videoUrl && !(videoUrl.includes('vimeo') || videoUrl.includes('youtu'));
  }
}
